import axios from "axios";
import { MessageBox, Message } from "element-ui";
import { getToken } from "@/utils/auth";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; 

NProgress.configure({ showSpinner: false }); 

// create an axios instance
const service = axios.create({
    baseURL: process.env.ROOT_API, // url = base url + request url
    //timeout: 60000, // request timeout
});

export function addTokenIntoAxiosHeader(token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

service.interceptors.request.use(function(config) {
    NProgress.start();
    config.headers["Authorization"] = "Bearer " + getToken();
    return config;
}, function(error) {
    return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
    
    /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

    /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
    response => {
        NProgress.done();
        const res = response.data.result;
        // if the custom code is not 20000, it is judged as an error.
        if (response.status !== 200) {
            Message({
                message: response.statusText || "Error",
                type: "error",
                duration: 5 * 1000
            });

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (response.status === 401 || response.status === 50012 || response.status === 50014) {
                // to re-login
                MessageBox.confirm("You have been logged out, you can cancel to stay on this page, or log in again", "Confirm logout", {
                    confirmButtonText: "Re-Login",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }).then(() => {
                });
            }
            return Promise.reject(new Error(response.statusText || "Error"));
        } else {
            return res || true;
        }
    },
    error => {
        console.log("error", error);
        if (error.status === 401) {
            // alert('Session Expired')
            console.log("session expired alert");
        }
        NProgress.done();
        var message = (((error.response || {}).data || {}).error || {}).message;
        Message({
            message: message ? message : error,
            type: "error",
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js